import React from 'react';
import parse from 'html-react-parser';

export default function AboutSectionStyle2({ title, subTitle, imgUrl }) {
  return (
    <section className="cs_shape_wrap">
      <div className="cs_shape_1 cs_position_5" />
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="cs_section_heading cs_style_1">
              <h2 className="cs_section_title cs_fs_72 m-0">{title}</h2>
              <div className="cs_height_54 cs_height_xl_30" />
              <div className="cs_about_intro">{parse(subTitle)}</div>
              <div className="cs_height_120 cs_height_xl_60" />
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <img src={imgUrl} alt={title} className="cs_radius_20 w-100" />
          </div>
        </div>
      </div>
    </section>
  );
}
